import React from "react";
import { Link } from "react-router-dom";
import AppDrawer from "./ui/AppDrawer";
import ro from "/src/content/ro.json";

const MyAccountDrawer = ({ open, onClose }) => {
  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      title={ro.accountDrawer.title}
      footer={
        <div className="drawer-actions">
          <Link to="/login" onClick={onClose} className="drawer-cta primary">
            {ro.accountDrawer.login}
          </Link>
          <Link to="/register" onClick={onClose} className="drawer-cta primary">
            {ro.accountDrawer.register}
          </Link>
        </div>
      }
    >
      <div className="drawer-center">
        <div className="drawer-card text-center flex flex-col items-center gap-4">
          <div className="w-[96px] h-[96px] flex items-center justify-center">
            <span className="drawer-icon-mask" aria-hidden="true" />
          </div>
          <p className="text-xl font-semibold leading-tight">
            {ro.accountDrawer.headlineBefore}{" "}
            <span className="text-orange-500 font-extrabold">
              {ro.accountDrawer.headlineHighlight}
            </span>
          </p>
        </div>
      </div>
    </AppDrawer>
  );
};

export default MyAccountDrawer;
